<template>
  <!-- SaaS announcements from the status poll; title/body in the current language, falling back
       to the other one. Dismissing hides one at once (App.vue stores it for this tenant). -->
  <div v-if="announcements.length" class="announcements-stack">
    <v-alert
      v-for="item in announcements"
      :key="item.id"
      :type="item.level === 'warning' ? 'warning' : 'info'"
      :icon="item.level === 'warning' ? 'mdi-alert-outline' : 'mdi-bullhorn-outline'"
      text
      dense
      :dismissible="item.dismissible !== false"
      class="mb-3"
      @input="value => onInput(item.id, value)"
    >
      <div v-if="titleOf(item)" class="font-weight-bold">{{ titleOf(item) }}</div>
      <div v-if="bodyOf(item)" class="announcement-body">{{ bodyOf(item) }}</div>
    </v-alert>
  </div>
</template>

<script>
import { localizedText } from "../../utils/saas-catalog";

export default {
  name: "AnnouncementsStack",
  props: {
    // [{ id, level, title: { en, ar }, body: { en, ar }, dismissible }]
    announcements: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    titleOf(item) {
      return localizedText(item.title, this.$i18n.locale);
    },
    bodyOf(item) {
      return localizedText(item.body, this.$i18n.locale);
    },
    onInput(id, value) {
      if (!value) this.$emit("dismiss", id);
    },
  },
};
</script>

<style scoped>
.announcement-body {
  white-space: pre-line;
}
</style>
